import api from './api';

export async function portfolioChat(message, history, analysisResult) {
  return (await api.post('/chat', { message, history, analysis_result: analysisResult })).data;
}

export async function screenerChat(message, history, screenResults) {
  return (await api.post('/chat/screener', { message, history, analysis_result: screenResults })).data;
}

export async function generateThesis(symbol, scoreData) {
  return (await api.post('/chat/thesis', { symbol, score_data: scoreData })).data;
}
